<template>
  <form :action="action" target="_blank" @submit="consultar" method="GET">
    <div class="layout">
      <div class="layout__header">
        <div class="layout__title">
          <h3>Reporte de comprobantes</h3>
        </div>
        <div class="layout__controls">
          <div class="form-inline">
            <button
              @click="clickConsultar"
              class="btn-info"
              type="submit"
              name="consultar"
              value="C"
            >
              <i class="fa fa-search"></i>
              <span>Consultar</span>
            </button>
            <button
              @click="clickExcel"
              class="btn-bus200"
              type="submit"
              name="consultar"
              value="E"
            >
              <i class="fa fa-file-excel-o"></i>
              <span>Imprimir Excel</span>
            </button>
            <button
              @click="clickPdf"
              class="btn-danger"
              type="submit"
              name="consultar"
              value="P"
            >
              <i class="fa fa-file-pdf-o"></i>
              <span>Imprimir PDF</span>
            </button>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card__title">
          <h5>Información de la consulta</h5>
        </div>
        <div class="card__content">
          <div class="row">
            <div class="col-xs-12 col-md-4">
              <div class="form-field select2">
                <div class="select2-field">
                  <v-select
                    @input="cargarPuntosEmision"
                    v-model="selectedTipoComprobante"
                    :options="listaTiposComprobante"
                    label="descripcion"
                    id="tipoComprobante"
                    placeholder="Seleccione..."
                  ></v-select>
                  <label for="tipoComprobante">Tipo de comprobante</label>
                  <input
                    type="hidden"
                    name="tipoComprobante"
                    v-model="form.tipoComprobante"
                  />
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="form-field select2">
                <div class="select2-field">
                  <v-select
                    v-model="selectedPuntoEmision"
                    :options="puntosEmision"
                    label="descripcion"
                    id="puntosEmision"
                    placeholder="Seleccione..."
                    @input="setearEstadosComprobante"
                  ></v-select>
                  <label for="puntosEmision">Puntos de emisión</label>
                  <input
                    type="hidden"
                    name="puntoEmision"
                    v-model="form.puntoEmision"
                  />
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="form-inline">
                <label for="comprobantes">
                  <input
                    @change="changeLogs"
                    v-model="form.filtro"
                    type="radio"
                    name="filtro"
                    id="comprobantes"
                    value="C"
                  />
                  <span>Comprobantes</span>
                </label>
                <label for="logs">
                  <input
                    @change="changeLogs"
                    v-model="form.filtro"
                    type="radio"
                    name="filtro"
                    id="logs"
                    value="L"
                  />
                  <span>Logs</span>
                </label>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="form-field select2">
                <div class="select2-field">
                  <v-select
                    @input="inputVendedor"
                    id="vendedor"
                    v-model="selectedVendedor"
                    :options="vendedores"
                    label="nombre"
                  ></v-select>
                  <label for="vendedor">Vendedor</label>
                  <input
                    type="hidden"
                    name="vendedorId"
                    v-model="form.vendedorId"
                  />
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="form-field">
                <input-field
                  name="numeroInicial"
                  v-model="form.numeroInicial"
                  v-mask="'###-###-#########'"
                  placeholder="# Comp (rango inicial)"
                  id="numeroInicial"
                  >Número de comp.</input-field
                >
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="form-inline">
                <label for="filtrarPorRangos">
                  <input
                    v-model="form.filtrarPorRangos"
                    type="checkbox"
                    name="filtrarPorRangos"
                    id="filtrarPorRangos"
                  />
                  <span>Filtrar por rangos de número</span>
                </label>
              </div>
            </div>
            <div v-show="form.filtrarPorRangos" class="col-xs-12 col-md-4">
              <div class="form-field">
                <div class="form-group">
                  <input-field
                    name="numeroFinal"
                    v-model="form.numeroFinal"
                    v-mask="'###-###-#########'"
                    placeholder="(Para filtrar por rangos)"
                    id="numeroFinal"
                  >
                    <span>Número límite comp.</span>
                  </input-field>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="form-field select2">
                <div class="select2-field">
                  <v-select
                    @input="inputEstadoComprobante"
                    v-model="selectedEstadoComprobante"
                    :options="estadosComprobante"
                    label="value"
                    id="estados"
                    placeholder="Seleccione..."
                  ></v-select>
                  <label for="estados">Estados de comprobante</label>
                  <input
                    type="hidden"
                    name="estadoComprobante"
                    :value="form.estadoComprobante"
                  />
                </div>
              </div>
            </div>
            <div v-show="!form.todos" class="col-xs-12 col-md-4">
              <div class="form-field">
                <div class="form-group">
                  <input-field
                    :disabled="form.idCliente !== ''"
                    name="numeroIdentificacion"
                    v-model="form.numeroIdentificacion"
                    id="numeroIdentificacion"
                    placeholder="##########"
                  >
                    <span>Número de identificación</span>
                  </input-field>
                  <button
                    v-show="form.idCliente === ''"
                    @click="cargarPersona"
                    type="button"
                    class="btn-success"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    v-show="form.idCliente !== ''"
                    @click="quitarCliente"
                    type="button"
                    class="btn-danger"
                  >
                    <i class="fa fa-ban"></i>
                  </button>
                </div>
              </div>
            </div>
            <div v-show="!form.todos" class="col-xs-12 col-md-4">
              <div class="form-field">
                <div class="form-group">
                  <input-field
                    name="nombreCliente"
                    v-model="form.nombreCliente"
                    readonly
                    id="nombreCliente"
                    placeholder="Seleccione..."
                  >
                    <span>Persona</span>
                  </input-field>
                  <input
                    type="hidden"
                    name="idCliente"
                    :value="form.idCliente"
                  />
                  <button
                    @click="$modal.show('cliente')"
                    type="button"
                    class="btn-info"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-8">
              <div class="form-inline">
                <div class="form-inline__content">
                  <label for="todos">
                    <input
                      @change="changeTodos"
                      v-model="form.todos"
                      type="checkbox"
                      name="todos"
                      id="todos"
                    />
                    <span>Todas las personas</span>
                  </label>
                  <label v-show="form.filtro === 'C'" for="conDetalles">
                    <input
                      @change="changeConDetalles"
                      v-model="form.conDetalles"
                      type="checkbox"
                      name="conDetalles"
                      id="conDetalles"
                    />
                    <span>Mostrar detalles del comp.</span>
                  </label>
                  <label for="pendientesPago">
                    <input
                      @change="changePendientesPago"
                      v-model="form.pendientesPago"
                      type="checkbox"
                      name="pendientesPago"
                      id="pendientesPago"
                    />
                    <span>Mostrar pendientes de pago</span>
                  </label>
                  <label for="pagados">
                    <input
                      @change="changePagados"
                      v-model="form.pagados"
                      type="checkbox"
                      name="pagados"
                      id="pagados"
                    />
                    <span>Mostrar pagados</span>
                  </label>
                  <label v-show="form.filtro === 'C'" for="abonados">
                    <input
                      @change="changeConAbonos"
                      v-model="form.abonados"
                      type="checkbox"
                      name="abonados"
                      id="abonados"
                    />
                    <span>Mostrar abonos</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="form-field select2">
                <div class="select2-field">
                  <v-select
                    id="tiposAbono"
                    v-model="selectedTiposAbono"
                    @input="inputTiposAbono"
                    :options="tiposAbono"
                    label="nombre"
                    placeholder="Seleccione..."
                    multiple
                  ></v-select>
                  <label for="tiposAbono">Tipos de abono</label>
                </div>
                <input
                  type="hidden"
                  name="tipos_abono[]"
                  v-for="tipoAbono in form.tipos_abono"
                  :key="tipoAbono"
                  :value="tipoAbono"
                />
              </div>
            </div>
            <div class="col-xs-12 col-md-8">
              <div class="form-field select2">
                <div class="select2-field">
                  <v-select
                    @search="onSearch"
                    placeholder="Seleccione..."
                    @input="inputItems"
                    multiple
                    id="items"
                    v-model="selectedItems"
                    :options="items"
                    label="nombre"
                  ></v-select>
                  <label for="items">Item(s)</label>
                </div>
                <input
                  type="hidden"
                  name="items[]"
                  :value="item.id"
                  v-for="item in selectedItems"
                  :key="item.id"
                />
              </div>
            </div>
            <div class="col-xs-12">
              <div class="form-inline">
                <label class="form-inline__title">Fecha</label>
                <div class="form-inline__content">
                  <label for="hoy">
                    <input
                      v-model="form.tipoFecha"
                      type="radio"
                      name="tipoFecha"
                      id="hoy"
                      value="H"
                    />
                    <span>Hoy</span>
                  </label>
                  <label for="ayer">
                    <input
                      v-model="form.tipoFecha"
                      type="radio"
                      name="tipoFecha"
                      id="ayer"
                      value="A"
                    />
                    <span>Ayer</span>
                  </label>
                  <label for="rango">
                    <input
                      @change="changeFechas"
                      v-model="form.tipoFecha"
                      type="radio"
                      name="tipoFecha"
                      id="rango"
                      value="R"
                    />
                    <span>Filtrar por fechas</span>
                  </label>
                  <div class="form-field" v-show="form.tipoFecha === 'R'">
                    <div class="datepicker-field datepicker-field--stretch">
                      <VueCtkDateTimePicker
                        id="fechaDesde"
                        v-model="form.fechaDesde"
                        locale="es"
                        no-label
                        only-date
                        auto-close
                        button-now-translation="Ahora"
                        format="YYYY-MM-DD"
                        formatted="YYYY-MM-DD"
                        label="Seleccione una fecha..."
                      />
                      <label>Desde</label>
                      <input
                        type="hidden"
                        name="fechaDesde"
                        v-model="form.fechaDesde"
                      />
                    </div>
                  </div>
                  <div class="form-field" v-show="form.tipoFecha === 'R'">
                    <div
                      class="datepicker-field datepicker-field--stretch"
                      v-show="form.tipoFecha === 'R'"
                    >
                      <VueCtkDateTimePicker
                        id="fechaHasta"
                        v-model="form.fechaHasta"
                        locale="es"
                        no-label
                        only-date
                        auto-close
                        button-now-translation="Ahora"
                        format="YYYY-MM-DD"
                        formatted="YYYY-MM-DD"
                        label="Seleccione una fecha..."
                      />
                      <label>Hasta</label>
                      <input
                        type="hidden"
                        name="fechaHasta"
                        v-model="form.fechaHasta"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <tabla-reporte-ventas
        :diasAlerta="diasAlerta"
        :conAbonos="form.abonados"
        v-if="filtroActual === 'C'"
        :conDetalles="form.conDetalles"
        :registros="registros"
      ></tabla-reporte-ventas>
      <tabla-logs-reporte-ventas
        v-if="filtroActual === 'L'"
        :logs="logs"
      ></tabla-logs-reporte-ventas>
      <div v-if="filtroActual === 'C'" class="card mt-2">
        <div class="card__title">
          <h5>Totales generales</h5>
        </div>
        <div class="card__content">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Tot. Sin Imp.</th>
                  <th>Subtotal IVA</th>
                  <th>Subtotal IVA 0%</th>
                  <th>Tot. IVA</th>
                  <th>Tot. ICE</th>
                  <th>Tot. IRBPNR</th>
                  <th>Tot. Ret. IVA</th>
                  <th>Tot. Ret. Renta</th>
                  <th>Tot. Comp.</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ moneyFormat(totales.total_sin_impuestos) }}</td>
                  <td>{{ moneyFormat(totales.subtotal_iva) }}</td>
                  <td>{{ moneyFormat(totales.subtotal_iva_0) }}</td>
                  <td>{{ moneyFormat(totales.total_iva) }}</td>
                  <td>{{ moneyFormat(totales.total_ice) }}</td>
                  <td>{{ moneyFormat(totales.total_irbpnr) }}</td>
                  <td>{{ moneyFormat(totales.total_ret_iva) }}</td>
                  <td>{{ moneyFormat(totales.total_ret_renta) }}</td>
                  <td>{{ moneyFormat(totales.total_comprobantes) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <modal height="auto" width="70%" name="cliente" scrollable>
        <lista-personas
          :filterStatus="false"
          @selected="selectedPersona"
        ></lista-personas>
      </modal>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    tiposComprobante: {
      type: Array,
      required: true,
    },
    vendedores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      },
    },
    diasAlerta: {
      required: false,
      default: 0,
    },
  },
  data: function() {
    return {
      items: [],
      selectedItems: [],
      tiposAbono: [
        {
          id: "EF",
          nombre: "Efectivo",
        },
        {
          id: "CH",
          nombre: "Cheque",
        },
        {
          id: "DEP",
          nombre: "Depósito bancario",
        },
        {
          id: "CRE",
          nombre: "Tarjeta de crédito",
        },
        {
          id: "DEB",
          nombre: "Tarjeta de débito",
        },
        {
          id: "TRANS",
          nombre: "Transferencia",
        },
        {
          id: "RET",
          nombre: "Retención",
        },
        {
          id: "NC",
          nombre: "Nota de crédito",
        },
      ],
      selectedTiposAbono: [],
      totales: {
        subtotal_iva: 0,
        subtotal_iva_0: 0,
        total_comprobantes: 0,
        total_sin_impuestos: 0,
        total_iva: 0,
        total_ice: 0,
        total_irbpnr: 0,
        total_ret_iva: 0,
        total_ret_renta: 0,
      },
      registros: [],
      comprobantesElectronicos: [],
      estadosComprobante: [],
      url: url,
      todos: true,
      selectedPuntoEmision: null,
      selectedEstadoComprobante: null,
      action: url + "/comprobantes/reporte",
      listaTiposComprobante: this.tiposComprobante,
      puntosEmision: [],
      selectedTipoComprobante: null,
      selectedVendedor: null,
      selectedTipoComprobante: null,
      moneyFormat: moneyFormat,
      form: {
        items: [],
        abonados: false,
        pagados: false,
        filtro: "C",
        tipoFecha: "H",
        fechaDesde: "",
        fechaHasta: "",
        numeroInicial: "",
        numeroFinal: "",
        estadoComprobante: "",
        todos: true,
        numeroIdentificacion: "",
        nombreCliente: "",
        idCliente: "",
        puntoEmision: "",
        conDetalles: false,
        filtrarPorRangos: false,
        pendientesPago: false,
        tipoComprobante: "",
        vendedorId: "",
        consultar: "C",
        tipos_abono: [],
      },
      filtroActual: "C",
      logs: [],
    };
  },
  methods: {
    clickPdf: function () {
      this.form.consultar = "P";
    },
    onSearch: function(search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function() {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.items = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/items-search?search=" + search, true);
      xmlhttp.send();
    },
    inputItems: function() {
      this.form.items.splice(0, this.form.items.length);
      for (let i = 0; i < this.selectedItems.length; i++) {
        this.form.items.push(this.selectedItems[i].id);
      }
    },
    inputTiposAbono: function() {
      this.form.tipos_abono.splice(0, this.form.tipos_abono.length);
      for (let i = 0; i < this.selectedTiposAbono.length; i++) {
        this.form.tipos_abono.push(this.selectedTiposAbono[i].id);
      }
    },
    changeConDetalles: function() {
      if (this.form.conDetalles) this.form.abonados = false;
    },
    changeConAbonos: function() {
      if (this.form.abonados) this.form.conDetalles = false;
    },
    changePendientesPago: function() {
      if (this.form.pendientesPago) this.form.pagados = false;
    },
    changePagados: function() {
      if (this.form.pagados) this.form.pendientesPago = false;
    },
    changeFechas: function() {
      let desde = new Date();
      desde.setDate(desde.getDate() - 7);
      this.form.fechaDesde = moment(desde).format("YYYY-MM-DD");
      this.form.fechaHasta = moment(new Date()).format("YYYY-MM-DD");
    },
    clickExcel: function() {
      this.form.consultar = "E";
    },
    clickConsultar: function() {
      this.form.consultar = "C";
    },
    selectedPersona: function(persona) {
      this.form.nombreCliente = persona.nombre;
      this.form.numeroIdentificacion = persona.identificacion;
      this.form.idCliente = persona.id;
      this.$modal.hide("cliente");
    },
    changeTodos: function() {
      if (this.todos) {
        this.form.idCliente = "";
        this.form.nombreCliente = "";
        this.form.numeroIdentificacion = "";
      }
    },
    quitarCliente: function() {
      this.form.nombreCliente = "";
      this.form.idCliente = "";
      this.form.numeroIdentificacion = "";
    },
    cargarPersona: function() {
      let that = this;
      if (this.form.numeroIdentificacion !== "") {
        axios
          .get(this.url + "/personas/" + this.form.numeroIdentificacion)
          .then(function(response) {
            that.form.nombreCliente = response.data.nombre;
            that.form.idCliente = response.data.id;
          })
          .catch(function(error) {
            if (error !== undefined && error !== null) {
              let response = error.response;
              if (response !== undefined && response !== null) {
                if (response.status === 404)
                  swal("No existe el cliente solicitado.", "Aviso", "warning");
                else
                  swal(
                    "Hubo un error al solicitar el cliente.",
                    "Error",
                    "error"
                  );
              }
            }
          });
      } else
        swal(
          "Debe ingresar el identificador del cliente.",
          "Mensaje",
          "warning"
        );
    },
    inputEstadoComprobante: function() {
      if (
        this.selectedEstadoComprobante !== null &&
        this.selectedEstadoComprobante !== undefined
      )
        this.form.estadoComprobante = this.selectedEstadoComprobante.id;
      else this.form.estadoComprobante = "";
    },
    consultar: function(event) {
      if (this.form.consultar === "C") {
        event.preventDefault();
        let that = this;
        axios
          .get(that.action, {
            params: that.form,
          })
          .then(function(response) {
            if (that.form.filtro === "C") {
              that.registros = response.data.registros;
              that.totales = response.data.totales;
              that.filtroActual = "C";
            } else {
              that.logs = response.data.registros;
              that.filtroActual = "L";
            }
          });
      }
    },
    inputVendedor: function() {
      if (this.selectedVendedor !== null)
        this.form.vendedorId = this.selectedVendedor.id;
      else this.form.vendedorId = "";
    },
    changeLogs: function() {
      if (this.form.filtro === "L") {
        if (
          this.selectedTipoComprobante !== null &&
          this.selectedTipoComprobante !== undefined
        ) {
          let existe = false;
          for (let i = 0; i < this.comprobantesElectronicos.length; i++)
            if (
              this.comprobantesElectronicos[i].id_tipo_comprobante ===
              this.selectedTipoComprobante.id_tipo_comprobante
            ) {
              existe = true;
              break;
            }
          if (!existe) this.selectedTipoComprobante = null;
        }
        this.listaTiposComprobante = this.comprobantesElectronicos;
      } else this.listaTiposComprobante = this.tiposComprobante;
    },
    cargarPuntosEmision: function() {
      if (
        this.selectedTipoComprobante !== null &&
        this.selectedTipoComprobante !== undefined
      ) {
        this.form.tipoComprobante = this.selectedTipoComprobante.id_tipo_comprobante;
        let that = this;
        axios
          .get(
            this.url +
              "/puntos-emision/" +
              this.form.tipoComprobante +
              "/lista",
            {
              params: {
                filtro: this.form.filtro,
              },
            }
          )
          .then(function(response) {
            that.puntosEmision = response.data;
          });
      } else {
        this.selectedPuntoEmision = null;
        this.form.tipoComprobante = "";
        this.puntosEmision = [];
      }
    },
    obtenerEstadosElectronicos: function() {
      return [
        {
          id: "T",
          value: "Todos",
        },
        {
          id: "E",
          value: "Emitidos",
        },
        {
          id: "PPR",
          value: "Pendientes",
        },
        {
          id: "AUT",
          value: "Autorizados",
        },
        {
          id: "NAT",
          value: "No autorizados",
        },
        {
          id: "A",
          value: "Anulados",
        },
      ];
    },
    obtenerEstadosManuales: function() {
      return [
        {
          id: "T",
          value: "Todos",
        },
        {
          id: "E",
          value: "Emitidos",
        },
        {
          id: "A",
          value: "Anulados",
        },
      ];
    },
    setearEstadosComprobante: function() {
      if (
        this.selectedPuntoEmision !== undefined &&
        this.selectedPuntoEmision !== null
      ) {
        this.form.puntoEmision = this.selectedPuntoEmision.id;
        // if (this.selectedPuntoEmision.tipo === "M")
        //   this.estadosComprobante = this.obtenerEstadosManuales();
        // else this.estadosComprobante = this.obtenerEstadosElectronicos();
      } else {
        // this.selectedEstadoComprobante = null;
        // this.estadosComprobante = [];
        this.form.puntoEmision = "";
      }
      this.estadosComprobante = this.obtenerEstadosElectronicos();
    }
  },
  mounted : function () {
    this.setearEstadosComprobante();
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/ReporteVentas.vue